import React from 'react';
import ReactDOM from 'react-dom';
import { LocalizeProvider } from 'react-localize-redux';
import App from './components/App';
import './styles/App.scss';
import * as Sentry from '@sentry/react';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code
} else {
  Sentry.init({
    environment: 'production',
    normalizeDepth: 10,
    maxBreadcrumbs: 15,
    dsn:
      'https://057ac9261b561355c8cd809312ec43eb@o4505002375446528.ingest.sentry.io/4506269473374208',
  });
}

// Render the React Tree
ReactDOM.render(
  <LocalizeProvider>
    <App />
  </LocalizeProvider>,
  document.getElementById('app')
);
